module.exports = __webpack_public_path__ + "static/media/Султанова А.А., Махота А.А., Яхина К.Р.66433b10.pdf";